<template>
  <v-layout>
    <v-btn v-if="loading" loading flat class="bottom-button" />
    <v-btn
      @click="onReadAll"
      v-else
      :disabled="!hasUnreadNotifications"
      class="bottom-button"
      xs3
      ma-2
    >
      全て既読にする
    </v-btn>
  </v-layout>
</template>

<script>
import { NotificationRepository } from '@/models/Notification'

export default {
  name: 'NotificationReadAllButton',
  props: {
    unreadNotificationList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasUnreadNotifications() {
      return this.unreadNotificationList.length !== 0
    },
  },
  methods: {
    async onReadAll() {
      if (!this.hasUnreadNotifications) return

      const allUnreadNotificationIds = this.unreadNotificationList
        .map(notification => notification.ids)
        .flat()
      await NotificationRepository.readNotification(allUnreadNotificationIds)
      this.unreadNotificationList.map(
        notification => (notification.isRead = true),
      )

      // 通知件数更新
      this.$emit('fetchUnreadNotificationsCount')
    },
  },
}
</script>

<style scoped lang="scss">
.bottom-button {
  margin-top: 10px;
  text-align: center;
}
</style>
